/** @format */

import { ProviderData } from "./URLGenerator";

export const fetchProvider = async () => {
  if (!jsonResponse) {
    const response = await fetch(ProviderData());
    jsonResponse = response.json();
  }
  return jsonResponse;
};

let jsonResponse = null;

const uniqueByKeepLast = (array, key) => {
  return [...new Map(array.map((item) => [item[key], item])).values()];
};

export const getCategories = (providers) => {
  const attributes = providers.flatMap(
    (provider) => provider.information.attributes
  );

  const equalAttributes = attributes.map((b) => {
    delete b.uid;
    return b;
  });

  return uniqueByKeepLast(equalAttributes, "label");
};
